import { Anchor as MantineAnchor, AnchorProps } from '@mantine/core';

export type IAnchorProps = AnchorProps;

/** @registry Design-layer pass-through over Mantine Anchor; import this instead of @mantine/core Anchor outside src/design. */
export const Anchor = MantineAnchor;
